import React from 'react'
import styled, { css } from 'styled-components'
import { useStoreState, useStoreActions } from 'easy-peasy'
import { Form, Alert } from 'reactstrap'
import inputs from '../components/form'
import BtnAction from '../components/form/BtnAction'
import Title from '../components/common/Title'
import FootNote from '../components/common/FootNote'
import Text from '../utils/Text'
import media from '../utils/media'

const Container = styled.div`
  text-align: center;
  .form-title {
    margin-top: 60px;
    ${props =>
      props.locale === 'en-us' &&
      css`
        margin-top: 20px;
      `}
    @media (min-width: 1280px) {
      margin-top: 10px;
      @media (min-height: 820px) {
        margin-top: 122px;
        ${props =>
          props.locale === 'en-us' &&
          css`
            margin-top: 80px;
          `}
      }
    }
    ${media.mobileL`
      margin-top: 10px;
    `}
  }
  .form-subtitle {
    max-width: 681px;
    margin: 0 auto;
  }
  #generalError {
    margin: -13px auto;
    max-width: 443px;
    border: none;
  }
  .form-footer {
    padding: 0 10px;
  }
`

const ContainerForm = styled.div`
  width: 100%;
  max-width: 993px;
  margin: 0 auto;
`

export default function FormPage({ step }) {
  const [
    { title, text, btn, footnote, form: formData },
    generalError,
    locale,
  ] = useStoreState(state => [
    state.steps.pages[step],
    state.form.generalError,
    state.locale.locale,
  ])
  const [submit] = useStoreActions(actions => [actions.form.submit])

  return (
    <Container className="form-component" locale={locale}>
      <Title
        title={title.text}
        titleSize={title.titleSize}
        titleColor={title.titleColor}
        marginBTitle={title.marginBTitle}
        classN="form-title"
      />
      <Title
        title={text.text}
        titleSize={text.titleSize}
        titleColor={text.titleColor}
        marginBTitle={text.marginBTitle}
        classN="form-subtitle"
      />
      <ContainerForm>
        <Form
          onSubmit={ev => {
            ev.preventDefault()
            submit()
          }}
        >
          {generalError &&
            generalError !==
              'server.errors.alreadyRegistered.message' && (
              <Alert id="generalError" fade={false} color="danger">
                <Text id={generalError} />
              </Alert>
            )}
          {formData.map(({ type, name, ...rest }) => {
            const InputComp = inputs[type]
            /* eslint-disable-next-line no-param-reassign */
            if (name === 'country') rest.value = locale
            return (
              <>
                <InputComp
                  key={`input-${name}`}
                  name={name}
                  // eslint-disable-next-line react/jsx-props-no-spreading
                  {...rest}
                />
                {type === 'Email' &&
                  generalError &&
                  generalError ===
                    'server.errors.alreadyRegistered.message' && (
                    <Alert
                      id="generalError"
                      fade={false}
                      color="danger"
                    >
                      <Text id={generalError} />
                    </Alert>
                  )}
              </>
            )
          })}
          <BtnAction id="submit" btn={btn} />
        </Form>
        {footnote && (
          <FootNote footnote={footnote} className="form-footer" />
        )}
      </ContainerForm>
    </Container>
  )
}
